import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Button, Icon } from "rbx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { downloadCSV } from "../../utils";
// import SelectVehicleModal from "./SelectVehicleModal";

const ActionButtons = ({
  onAddClick,
  type,
  size,
  filters,
  setFilters,
  setModalOpen,
  FilterComponent,
  onDeleteAllClick,
  onSaveClick,
  client,
  name,
  query,
  columns,
  where,
  readOnly
  // Auth,
  // Codes
}) => (
  <div className="page-head-end">
    {type === "codes" ? (
      <Field kind="group">
        <Control>
          <Control>
            <Button
              color="danger"
              size={size}
              onClick={() =>
                setModalOpen(
                  true,
                  <FilterComponent
                    filters={filters}
                    onClose={() => setModalOpen(false)}
                    onFilter={setFilters}
                  />
                )
              }
            >
              <Icon>
                <FontAwesomeIcon icon="filter" />
              </Icon>
              <span>Filter</span>
            </Button>
          </Control>
        </Control>
        <Control>
          <Button
            color="primary"
            size={size}
            onClick={() =>
              downloadCSV(
                client,
                {
                  query,
                  where: where ? { ...where } : { ...filters }
                },
                name,
                columns
              )
            }
          >
            <Icon>
              <FontAwesomeIcon icon="file-export" />
            </Icon>
            <span>Export</span>
          </Button>
        </Control>
        <Control>
          <Button
            color="success"
            disabled={readOnly}
            size={size}
            onClick={onAddClick}
          >
            <Icon>
              <FontAwesomeIcon icon="plus" />
            </Icon>
            <span>Add</span>
          </Button>
        </Control>
      </Field>
    ) : (
      <Field kind="group">
        {/* {Auth && (Auth.MechanicAuth || Auth.AdminAuth || Auth.FleetAuth) && (
          <Control>
            <Button
              size={size}
              color="link"
              disabled={!Codes?.VehicleType || !Codes?.InspectionCode}
              onClick={() =>
                setModalOpen(
                  true,
                  <SelectVehicleModal
                    Codes={Codes}
                    onClose={() => setModalOpen(false)}
                  />
                )
              }
            >
              <Icon>
                <FontAwesomeIcon icon="print" />
              </Icon>
              <span>Print</span>
            </Button>
          </Control>
        )} */}
        <Control>
          <Button
            color="danger"
            disabled={readOnly}
            size={size}
            onClick={onDeleteAllClick}
          >
            <Icon>
              <FontAwesomeIcon icon="trash" />
            </Icon>
            <span>Delete All</span>
          </Button>
        </Control>
        <Control>
          <Button
            color="primary"
            size={size}
            onClick={() =>
              downloadCSV(
                client,
                {
                  query,
                  where: where ? { ...where } : { ...filters }
                },
                name,
                columns
              )
            }
          >
            <Icon>
              <FontAwesomeIcon icon="file-export" />
            </Icon>
            <span>Export</span>
          </Button>
        </Control>
        <Control>
          <Button
            color="success"
            disabled={readOnly}
            size={size}
            onClick={onSaveClick}
          >
            <Icon>
              <FontAwesomeIcon icon="save" />
            </Icon>
            <span>Save</span>
          </Button>
        </Control>
      </Field>
    )}
  </div>
);

ActionButtons.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.string,
  onAddClick: PropTypes.func,
  setFilters: PropTypes.func,
  setModalOpen: PropTypes.func,
  onDeleteAllClick: PropTypes.func,
  onSaveClick: PropTypes.func,
  query: PropTypes.object,
  filters: PropTypes.object,
  client: PropTypes.object,
  FilterComponent: PropTypes.node,
  columns: PropTypes.array,
  where: PropTypes.object,
  readOnly: PropTypes.bool
  // Auth: PropTypes.object,
  // Codes: PropTypes.object
};

export default ActionButtons;
